import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { deFondo } from "src/app/security/helper/peticion-de-fondo";
import { EquipoHoy } from "src/app/shared/model/security/equipo-hoy.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

@Injectable({
  providedIn: "root",
})
export class EquipoService {
  constructor(private http: HttpClient) {}

  /**
   * Va de fondo: es un adorno de Inicio, y un 401 aquí no debe arrancarle
   * la pantalla al usuario; el bloque simplemente no se pinta.
   */
  hoy(): Observable<EquipoHoy> {
    return this.http.post<EquipoHoy>(UrlConstantes.EQUIPO_HOY, {}, { context: deFondo() });
  }
}
